import {useEffect} from 'react';

export function useConnect({emitter, listeners}: MessagesEmitterProps): void {
  useEffect(() => {
    emitter.connect(...listeners);
  }, [emitter, listeners]);
}
